// extracted by mini-css-extract-plugin
export default {"wrapper":"Toggle_wrapper__DHGH+","formField":"Toggle_formField__JyosX","toggle":"Toggle_toggle__AdTtV"};